import type { SpacingScale } from '@/theme/types'

export const spacing: SpacingScale = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 32,
  8: 40,
}

